import { useGame } from '@/contexts/GameContext';
import SettingsMenu from './SettingsMenu';
import type { GameSettings } from '@/types/game';

interface SettingsMenuWrapperProps {
  isOpen: boolean;
  onClose: () => void;
  onRestart?: () => void;
  onGoHome?: () => void;
  onToggleFullscreen?: () => void;
}

function SettingsMenuWrapper({
  isOpen,
  onClose,
  onRestart,
  onGoHome,
  onToggleFullscreen,
}: SettingsMenuWrapperProps) {
  const { gameState, updateGameState } = useGame();

  const handleSettingsChange = (settings: Partial<GameSettings>) => {
    updateGameState({
      gameSettings: {
        ...gameState.gameSettings,
        ...settings,
      },
    });
  };

  return (
    <SettingsMenu
      isOpen={isOpen}
      settings={gameState.gameSettings}
      onClose={onClose}
      onSettingsChange={handleSettingsChange}
      onRestart={onRestart}
      onGoHome={onGoHome}
      onToggleFullscreen={onToggleFullscreen}
    />
  );
}

export default SettingsMenuWrapper;